function selectionSignature(ids) {
  if (!ids || ids.size === 0) return '';
  return Array.from(ids).sort().join('|');
}

function lockSignature(lockStates) {
  if (!lockStates) return '';
  let sig = '';
  for (const id in lockStates) {
    const state = lockStates[id];
    if (!state) continue;
    // The clock rewrites "30s" every second. That must not rebuild the board.
    const reason = String(state.lockReason || '').replace(/\d+s\b/g, '');
    sig += `${id}:${state.isLocked ? 1 : 0}:${state.isExcluded ? 1 : 0}:${reason}|`;
  }
  return sig;
}

function hudSignature(flow) {
  const view = flow?.flowViewVisibility || {};
  return [
    flow?.sprintName || '',
    flow?.sprintIcon || '',
    flow?.sprintProgress ?? '',
    view.activeMissions !== false ? 1 : 0,
    view.availableMissions !== false ? 1 : 0,
    view.milestones !== false ? 1 : 0,
    view.minimap !== false ? 1 : 0,
  ].join('|');
}

function chainSignature(chains) {
  if (!Array.isArray(chains) || chains.length === 0) return '';
  return [...chains]
    .map((chain) => `${chain?.id || ''}:${chain?.order ?? ''}`)
    .sort()
    .join('|');
}

function listSignature(list) {
  if (!list?.length) return '';
  let sig = String(list.length);
  for (let i = 0; i < list.length; i += 1) {
    const item = list[i];
    sig += `|${item?.id || ''}:${item?.name || ''}:${item?.color || ''}`;
  }
  return sig;
}

/** The campaign clock rebuilds parent props about once a second. Skip that render while dragging. */
export function sameBoardProps(prev, next) {
  if (prev.tasks !== next.tasks || prev.statuses !== next.statuses || prev.onOpenDetails !== next.onOpenDetails) {
    return false;
  }
  if (selectionSignature(prev.selectedIds) !== selectionSignature(next.selectedIds)) return false;
  if (prev.fokus?.active !== next.fokus?.active) return false;
  if (prev.fokus?.focusedCount !== next.fokus?.focusedCount) return false;
  if (prev.fokus?.totalVisibleCount !== next.fokus?.totalVisibleCount) return false;
  if (lockSignature(prev.lockStates) !== lockSignature(next.lockStates)) return false;
  const a = prev.flowProps || {};
  const b = next.flowProps || {};
  return a.campaignId === b.campaignId
    && hudSignature(a) === hudSignature(b)
    && a.cardDisplaySettings === b.cardDisplaySettings
    && a.nestedSprints === b.nestedSprints
    && a.customFields === b.customFields
    && a.allSprints === b.allSprints
    && a.isTemplate === b.isTemplate
    && listSignature(a.allTags) === listSignature(b.allTags)
    && listSignature(a.allCategories) === listSignature(b.allCategories)
    && chainSignature(a.chains) === chainSignature(b.chains);
}
